import { createContext, useContext, useMemo, useState } from 'react';

export const SITE_SESSION_STORAGE_KEY = 'opticdev.siteSession';

function readStoredSession() {
  try {
    const raw = localStorage.getItem(SITE_SESSION_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_error) {
    return null;
  }
}

const SiteSessionContext = createContext(null);

export function SiteSessionProvider({ children }) {
  const [session, setSessionState] = useState(readStoredSession);

  const setSession = (nextSession) => {
    setSessionState(nextSession);
    if (nextSession) {
      localStorage.setItem(SITE_SESSION_STORAGE_KEY, JSON.stringify(nextSession));
    } else {
      localStorage.removeItem(SITE_SESSION_STORAGE_KEY);
    }
  };

  const value = useMemo(
    () => ({
      session,
      isAdmin: session?.mode === 'admin',
      site: session?.site || null,
      siteType: session?.site?.type || null,
      permissions: session?.permissions || session?.user?.permissions || [],
      hasPermission: (code) =>
        session?.mode === 'admin' ||
        (session?.permissions || session?.user?.permissions || []).some((permission) =>
          typeof permission === 'string' ? permission === code : permission?.code === code
        ),
      setSession,
      disconnect: () => setSession(null),
    }),
    [session]
  );

  return <SiteSessionContext.Provider value={value}>{children}</SiteSessionContext.Provider>;
}

export function useSiteSession() {
  return useContext(SiteSessionContext);
}
